export default {
  title: {
    id: 'bo_seller-homepage-feedback_title',
    defaultMessage: 'Share your feedback',
  },
  feedbackBlockTitle: {
    id: 'merchant_home_page_feedback_title',
    defaultMessage: 'How are you liking the Back Office?',
  },
  feedbackBlockDescription: {
    id: 'merchant_home_page_feedback_description',
    defaultMessage:
      'Help us improve your workspace! Take a few moments to tell us what you think of the Back Office.',
  },
  feedbackBlockButton: {
    id: 'merchant_home_page_feedback_button',
    defaultMessage: 'Share your feedback',
  },
}
